import { ChevronIcon } from '@ardoq/icons';
import { GhostButton } from '@ardoq/button';
import { PaginationWithoutNumbersProps } from './types';
import { Ellipsis, Wrapper } from './atoms';

export const PaginationWithoutNumbers = ({
  hasNextPage,
  hasPreviousPage,
  onNextPress,
  onPreviousPress,
  isDisabled,
  previousButtonDataTestId,
  nextButtonDataTestId,
  onFirstPagePress,
  currentPage,
  previousLabel = 'Previous',
  nextLabel = 'Next',
}: PaginationWithoutNumbersProps) => {
  return (
    <Wrapper $isDisabled={isDisabled}>
      <GhostButton
        isDisabled={!hasPreviousPage}
        onClick={onPreviousPress}
        dataTestId={previousButtonDataTestId}
      >
        <ChevronIcon direction="left" />
        {previousLabel}
      </GhostButton>
      {currentPage > 1 && (
        <>
          <GhostButton
            onClick={onFirstPagePress}
            dataTestId="first-page-button"
          >
            1
          </GhostButton>
          {currentPage > 2 && <Ellipsis />}
          <GhostButton isActive>{currentPage}</GhostButton>
        </>
      )}
      <GhostButton
        isDisabled={!hasNextPage}
        onClick={onNextPress}
        dataTestId={nextButtonDataTestId}
      >
        {nextLabel}
        <ChevronIcon direction="right" />
      </GhostButton>
    </Wrapper>
  );
};
